import { AnalyticsConstants } from '../../adapters/helpers/ConstantsGA';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import VideoPlayerFactory from '../../adapters/helpers/VideoPlayerFactory';
import { VideoPlayerConstants } from '../../adapters/helpers/Constants';
class VideoPlayer extends Component {
  constructor(props) {
    super(props);
    this.videoRef = React.createRef();
    this.videoPlayer = null;
    this.video = props.video;
    this.state = {
      video: null
    };
  }
  getVideo() {
    return this.video;
  }
  getVideoRef() {
    var _this$videoRef;
    return (_this$videoRef = this.videoRef) == null ? void 0 : _this$videoRef.current;
  }
  getVideoCustomID(string) {
    let videoCustomId = this.video.assetId;
    videoCustomId = videoCustomId.split('/');
    return string + '-' + videoCustomId[videoCustomId.length - 1];
  }
  getVideoPlayerRef() {
    return this.videoPlayer;
  }
  componentDidMount() {
    if (this.videoIsDefined()) {
      const videoPlayerFactory = new VideoPlayerFactory(this.videoRef, this.video);
      this.createVideoPlayer(videoPlayerFactory);
    }
  }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.state && this.state.video && this.video !== this.props.video) {
      var _this$props$video, _this$props$video$sub, _this$props$video2, _this$props$video2$ca, _this$props$video2$ca2, _this$props$video3, _this$props$video3$ca, _this$props$video3$ca2, _this$props$video4, _this$props$video4$ca, _this$props$video4$ca2, _this$props$video5, _this$props$video5$ca, _this$props$video5$ca2, _this$video$asset, _this$video$asset$fie, _this$video$asset$fie2, _this$props$video6;
      const subTitles = (_this$props$video = this.props.video) == null ? void 0 : (_this$props$video$sub = _this$props$video.subTitles) == null ? void 0 : _this$props$video$sub.map(subtitle => {
        var _subtitle$fields, _subtitle$fields2, _subtitle$fields3;
        return {
          label: subtitle == null ? void 0 : (_subtitle$fields = subtitle.fields) == null ? void 0 : _subtitle$fields.label,
          language: subtitle == null ? void 0 : (_subtitle$fields2 = subtitle.fields) == null ? void 0 : _subtitle$fields2.language,
          url: subtitle == null ? void 0 : (_subtitle$fields3 = subtitle.fields) == null ? void 0 : _subtitle$fields3.url
        };
      });
      const textTracks = {
        captions: {
          label: (_this$props$video2 = this.props.video) == null ? void 0 : (_this$props$video2$ca = _this$props$video2.captions) == null ? void 0 : (_this$props$video2$ca2 = _this$props$video2$ca.fields) == null ? void 0 : _this$props$video2$ca2.label,
          default: (_this$props$video3 = this.props.video) == null ? void 0 : (_this$props$video3$ca = _this$props$video3.captions) == null ? void 0 : (_this$props$video3$ca2 = _this$props$video3$ca.fields) == null ? void 0 : _this$props$video3$ca2.default,
          language: (_this$props$video4 = this.props.video) == null ? void 0 : (_this$props$video4$ca = _this$props$video4.captions) == null ? void 0 : (_this$props$video4$ca2 = _this$props$video4$ca.fields) == null ? void 0 : _this$props$video4$ca2.language,
          url: (_this$props$video5 = this.props.video) == null ? void 0 : (_this$props$video5$ca = _this$props$video5.captions) == null ? void 0 : (_this$props$video5$ca2 = _this$props$video5$ca.fields) == null ? void 0 : _this$props$video5$ca2.url
        },
        subtitles: subTitles && [...subTitles]
      };
      this.state.video.source((_this$video$asset = this.video.asset) == null ? void 0 : (_this$video$asset$fie = _this$video$asset.fields) == null ? void 0 : (_this$video$asset$fie2 = _this$video$asset$fie.file) == null ? void 0 : _this$video$asset$fie2.url, {
        textTracks: subTitles && ((_this$props$video6 = this.props.video) == null ? void 0 : _this$props$video6.captions) && textTracks
      });
      if (this.props.video.videoSettings) {
        const videoSettings = this.props.video.videoSettings.fields;
        const transformations = {
          video_codec: (videoSettings == null ? void 0 : videoSettings.videoFormat) || 'auto',
          quality: (videoSettings == null ? void 0 : videoSettings.quality) || 'auto',
          width: (videoSettings == null ? void 0 : videoSettings.width) || null,
          height: (videoSettings == null ? void 0 : videoSettings.height) || null,
          crop: (videoSettings == null ? void 0 : videoSettings.crop) || 'limit'
        };
        this.state.video.transformation(transformations);
      }
    }
  }
  createVideoPlayer(videoPlayerFactory) {
    var _this$props$video7, _this$props$video7$su, _this$props$video8, _this$props$video8$ca, _this$props$video8$ca2, _this$props$video9, _this$props$video9$ca, _this$props$video9$ca2, _this$props$video10, _this$props$video10$c, _this$props$video10$c2, _this$props$video11, _this$props$video11$c, _this$props$video11$c2, _this$props$video12;
    const subTitles = (_this$props$video7 = this.props.video) == null ? void 0 : (_this$props$video7$su = _this$props$video7.subTitles) == null ? void 0 : _this$props$video7$su.map(subtitle => {
      var _subtitle$fields4, _subtitle$fields5, _subtitle$fields6;
      return {
        label: subtitle == null ? void 0 : (_subtitle$fields4 = subtitle.fields) == null ? void 0 : _subtitle$fields4.label,
        language: subtitle == null ? void 0 : (_subtitle$fields5 = subtitle.fields) == null ? void 0 : _subtitle$fields5.language,
        url: subtitle == null ? void 0 : (_subtitle$fields6 = subtitle.fields) == null ? void 0 : _subtitle$fields6.url
      };
    });
    let textTracks = {
      captions: {
        label: (_this$props$video8 = this.props.video) == null ? void 0 : (_this$props$video8$ca = _this$props$video8.captions) == null ? void 0 : (_this$props$video8$ca2 = _this$props$video8$ca.fields) == null ? void 0 : _this$props$video8$ca2.label,
        default: (_this$props$video9 = this.props.video) == null ? void 0 : (_this$props$video9$ca = _this$props$video9.captions) == null ? void 0 : (_this$props$video9$ca2 = _this$props$video9$ca.fields) == null ? void 0 : _this$props$video9$ca2.default,
        language: (_this$props$video10 = this.props.video) == null ? void 0 : (_this$props$video10$c = _this$props$video10.captions) == null ? void 0 : (_this$props$video10$c2 = _this$props$video10$c.fields) == null ? void 0 : _this$props$video10$c2.language,
        url: (_this$props$video11 = this.props.video) == null ? void 0 : (_this$props$video11$c = _this$props$video11.captions) == null ? void 0 : (_this$props$video11$c2 = _this$props$video11$c.fields) == null ? void 0 : _this$props$video11$c2.url
      },
      subtitles: subTitles && [...subTitles]
    };
    textTracks = subTitles && ((_this$props$video12 = this.props.video) == null ? void 0 : _this$props$video12.captions) && textTracks;
    const source = textTracks ? {
      sourceTypes: ['webm', 'mp4', 'hls', 'ogg'],
      textTracks: textTracks
    } : {
      sourceTypes: ['webm', 'mp4', 'hls', 'ogg']
    };
    videoPlayerFactory.create().then(({
      videoPlayer,
      transformation
    }) => {
      var _this$video$asset2, _this$video$asset2$fi, _this$video$asset2$fi2;
      const video = videoPlayer.Cloudinary.new({
        secure: true
      }).videoPlayer(this.videoRef.current, {
        muted: this.video.muted,
        loop: this.video.loop,
        fontFace: 'inherit',
        fluid: true,
        preload: this.video.preload ? true : false,
        controls: this.video.controls,
        autoplayMode: this.video.autoplay,
        playsinline: this.video.playsInline
      }).transformation(transformation).source((_this$video$asset2 = this.video.asset) == null ? void 0 : (_this$video$asset2$fi = _this$video$asset2.fields) == null ? void 0 : (_this$video$asset2$fi2 = _this$video$asset2$fi.file) == null ? void 0 : _this$video$asset2$fi2.url, source);
      this.setState({
        video: video
      });
      this.videoPlayer = video;
      this.videoPlayer.on('canplay', this.onVideoLoaded.bind(this));
      this.videoPlayer.on('play', this.onVideoPlay.bind(this));
      this.videoPlayer.on('pause', this.onVideoPause.bind(this));
      this.videoPlayer.on('mute', this.onVideoMuted.bind(this));
      this.videoPlayer.on('unmute', this.onVideoUnMuted.bind(this));
      this.videoPlayer.on('fullscreenchange', this.onVideoFullScreen.bind(this));
    }).catch(() => {});
  }
  componentWillUnmount() {
    if (this.videoPlayer) {
      this.videoPlayer.off('canplay', this.onVideoLoaded.bind(this));
      this.videoPlayer.off('play', this.onVideoPlay.bind(this));
      this.videoPlayer.off('pause', this.onVideoPause.bind(this));
      this.videoPlayer.off('mute', this.onVideoMuted.bind(this));
      this.videoPlayer.off('unmute', this.onVideoUnMuted.bind(this));
      this.videoPlayer.off('fullscreenchange', this.onVideoFullScreen.bind(this));
    }
  }
  onVideoLoaded() {
    this.videoPlayer.off('canplay', this.onVideoLoaded.bind(this));
    this.setAnalyticsPlayPauseTags();
    this.setAnalyticsMuteUnmuteTags();
    this.setAnalyticsFullScreenTags();
    this.setAnalyticsCaptionsTags();
    this.setVideoDOMContent();
  }
  onVideoPause() {
    if (this.props.onVideoPlaying) {
      this.props.onVideoPlaying(false);
    }
    this.setAnalyticsPlayPauseTags();
  }
  onVideoPlay() {
    if (this.props.onVideoPlaying) {
      this.props.onVideoPlaying(true);
    }
    this.setAnalyticsPlayPauseTags();
  }
  onVideoMuted() {
    this.setAnalyticsMuteUnmuteTags();
  }
  onVideoUnMuted() {
    this.setAnalyticsMuteUnmuteTags();
  }
  onVideoFullScreen() {
    this.setAnalyticsFullScreenTags();
  }
  setAnalyticsPlayPauseTags() {
    if (this.videoRef.current.parentNode) {
      let isVideoPaused = this.videoRef.current.parentNode.classList.contains('vjs-paused');
      let playPauseButton = this.videoRef.current.parentNode.querySelector('button.vjs-play-control');
      this.setElementAnalytics(playPauseButton, 'event-video-play', AnalyticsConstants.videoPlayText, AnalyticsConstants.videoPauseText, !isVideoPaused);
      let bigPlayButton = this.videoRef.current.parentNode.querySelector('button.vjs-big-play-button');
      this.setElementAnalytics(bigPlayButton, 'event-video-play', AnalyticsConstants.videoPlayText, AnalyticsConstants.videoPauseText, !isVideoPaused);
    }
  }
  setAnalyticsMuteUnmuteTags() {
    if (this.videoRef.current.parentNode) {
      let isVideoMuted = this.videoRef.current.getAttribute('muted');
      let muteUnmuteButton = this.videoRef.current.parentNode.querySelector('button.vjs-mute-control');
      this.setElementAnalytics(muteUnmuteButton, 'event-button-click', AnalyticsConstants.videoUnmuteText, AnalyticsConstants.videoMuteText, !isVideoMuted);
    }
  }
  setAnalyticsFullScreenTags() {
    if (this.videoRef.current.parentNode) {
      let isVideoFullScreen = this.videoRef.current.parentNode.classList.contains('vjs-fullscreen');
      let fullscreenButton = this.videoRef.current.parentNode.querySelector('button.vjs-fullscreen-control');
      this.setElementAnalytics(fullscreenButton, 'event-button-click', AnalyticsConstants.videoFullscreenOffText, AnalyticsConstants.videoFullscreenOnText, !isVideoFullScreen);
    }
  }
  setAnalyticsCaptionsTags() {
    if (this.videoRef.current.parentNode) {
      let isCaptionsVisible = this.videoRef.current.parentNode.querySelector('div.vjs-text-track-cue');
      let captionsButton = this.videoRef.current.parentNode.querySelector('button.vjs-subs-caps-button');
      this.setElementAnalytics(captionsButton, 'event-button-click', AnalyticsConstants.videoCloseCaptionsOffText, AnalyticsConstants.videoCloseCaptionsOnText, !isCaptionsVisible);
    }
  }
  setElementAnalytics(element, className, dataActionDetail, dataActionDetailAlternative = '', isAlternative = false) {
    if (element) {
      if (!element.classList.contains(className)) {
        element.classList.add(className);
      }
      if (!isAlternative) {
        element.setAttribute('data-action-detail', dataActionDetail);
      } else {
        element.setAttribute('data-action-detail', dataActionDetailAlternative);
      }
    }
  }
  setVideoDOMContent() {
    if (this.videoRef.current.parentNode) {
      let overlayItem = this.videoRef.current.parentNode.querySelector('div.vjs-recommendations-overlay-item-info');
      let cloudinaryButton = this.videoRef.current.parentNode.querySelector('a.vjs-cloudinary-button');
      if (cloudinaryButton) {
        cloudinaryButton.innerHTML = "Cloudinary Logo";
      }
      if (overlayItem) {
        let h2Ele = overlayItem.getElementsByTagName('h2');
        let h3Ele = overlayItem.getElementsByTagName('h3');
        h2Ele && h2Ele[0] ? h2Ele[0].innerHTML = VideoPlayerConstants.videoRecommendations : '';
        h3Ele && h3Ele[0] ? h3Ele[0].innerHTML = VideoPlayerConstants.videoRecommendations : '';
      }
    }
  }
  videoIsDefined() {
    var _this$video$asset3, _this$video$asset3$fi, _this$video$asset3$fi2;
    return this.video && ((_this$video$asset3 = this.video.asset) == null ? void 0 : (_this$video$asset3$fi = _this$video$asset3.fields) == null ? void 0 : (_this$video$asset3$fi2 = _this$video$asset3$fi.file) == null ? void 0 : _this$video$asset3$fi2.url);
  }
  renderTranscript() {
    return <div className="video-player-transcript visuallyhidden">{this.video.transcript}</div>;
  }
  render() {
    var _this$props$video13, _this$video$asset4, _this$video$asset4$fi, _this$video$asset4$fi2;
    const ariaLabel = (_this$props$video13 = this.props.video) == null ? void 0 : _this$props$video13.ariaLabel;
    return <>
            <div className="ob-video-player">
                <video muted playsInline id={this.getVideoCustomID(VideoPlayerConstants.id)} aria-label={ariaLabel} ref={this.videoRef}>
                    <source src={'https:' + ((_this$video$asset4 = this.video.asset) == null ? void 0 : (_this$video$asset4$fi = _this$video$asset4.fields) == null ? void 0 : (_this$video$asset4$fi2 = _this$video$asset4$fi.file) == null ? void 0 : _this$video$asset4$fi2.url)} type='video/mp4' />
                </video>
                {this.renderTranscript()}
            </div>
            </>;
  }
}
VideoPlayer.propTypes = {
  video: PropTypes.object,
  onVideoPlaying: PropTypes.func
};
export default VideoPlayer;